// Copyright (c) Siemens AG 2026 ALL RIGHTS RESERVED.
//
// mySiESTA

up.compiler('.search-widget--loading', function(element) {
  const show = () => up.element.show(element)
  const hide = () => up.element.hide(element)

  const unbindLate = up.on('up:network:late', show)
  const unbindRecover = up.on('up:network:recover', hide)

  return () => {
    unbindLate()
    unbindRecover()
  }
})

// html5 autofocus does not work when fragment is loaded via AJAX
// in a modal, so we register a handler to handle autofocus inside modals
up.on('up:layer:opened', function(event, element) {
  const input = element.querySelector('up-modal .search-widget--input')
  if (input && input.getAttribute('autofocus')) {
    input.focus()
  }
})
